
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useClientCompanyDetails } from './CompanyMenu/UseClientCompanyDetails';
import CustomCollapse from '../common/CustomCollapse';
import ClientCompanyDetail from './CompanyMenu/ClientCompanyDetail';
import CustomModal from '../common/CustomModal';
import CreateCompanyInfo from './CompanyMenu/CreateCompanyInfo';
import MessageBox from '../.../../common/CustomMessageBox';
import { GET_clientCompany_TaxId } from '../../services/apiRoutes';
import axios from 'axios';
import UpdateCompanyInfo from './CompanyMenu/UpdateCompanyInfo';
import CustomLoader from '../common/CustomLoader';
import { Box } from '@mui/material';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { CompanyTask } from './CompanyMenu/CompanyTask';
import { CompanyCall } from './CompanyMenu/CompanyCall';
import { CompanyNotes } from './CompanyMenu/CompanyNotes';


export default function PersistentDrawerLeft() {
    const navigate = useNavigate();  // Initialize useNavigate
    const { clientCompanyId } = useParams();
    const { companyDetail } = useClientCompanyDetails(clientCompanyId);
    const [modal, setModal] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [updateModal, setUpdateModal] = useState(false);
    const [open, setOpen] = React.useState(true);
    const [activeTab, setActiveTab] = React.useState('Overview'); // Track active tab
    const [tax, setTax] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state for fetch operation
    const [error, setError] = useState(null); // Error state


    const fetchCompanyTax = async () => {
        const authToken = sessionStorage.getItem('accessToken');
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(GET_clientCompany_TaxId(clientCompanyId), {
                headers: { Authorization: `Bearer ${authToken}` }
            });

            const { companyTax } = response.data;
            if (companyTax && companyTax.length > 0) {
                setTax(companyTax[0]);
            } else {
                setTax({});
            }
        } catch (err) {
            setError('Error fetching company tax details');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (clientCompanyId) {
            fetchCompanyTax();
        }
    }, [clientCompanyId]);



    if (!companyDetail) {
        return (
            <Box>
                <CustomLoader open={loading} />
            </Box>
        );
    }

    const clientCompanyTax = companyDetail.clientCompanyId;
    const companyName = companyDetail.clientCompanyName;
    const phoneNumber = companyDetail.mobile;
    const initial = companyDetail.clientCompanyName ? companyDetail.clientCompanyName.charAt(0).toUpperCase() : '';


    const adminData = [
        {
            title: "Company Admin",
            defaultExpanded: false,
            details: [
                { label: 'Company Admin', value: `${companyDetail.companyAdmin.firstName || ''} ${companyDetail.companyAdmin.lastName || ''}`.trim() },
                { label: 'Email', value: companyDetail.user.email, sm: 12, md: 12 },
                {
                    label: 'Mobile',
                    value: companyDetail?.user?.mobile && companyDetail?.user?.phonecode?.phonecode
                        ? `+${companyDetail.user.phonecode.phonecode}${companyDetail.user.mobile}`
                        : companyDetail?.user?.mobile || '',
                    sm: 12,
                    md: 12
                },
            ],
        },
    ];

    const clientCompany = [
        {
            title: companyDetail.clientCompanyName,
            defaultExpanded: false,
            details: [
                { label: 'Email', value: companyDetail.email, sm: 12, md: 4 },
                {
                    label: 'Mobile',
                    value:
                        companyDetail?.mobile && companyDetail?.phonecode?.phonecode
                            ? `+${companyDetail.phonecode.phonecode}${companyDetail.mobile}`
                            : companyDetail?.mobile || '',
                    sm: 12, md: 4
                },
                { label: 'Phone', value: companyDetail.phone, sm: 12, md: 4 },
                { label: 'Company Type', value: companyDetail.companyType.companyTypeName, sm: 12, md: 4 },
                { label: 'Industry', value: companyDetail.industryType.industryTypeName, sm: 12, md: 4 },
                { label: 'Business Group', value: companyDetail?.BusinessGroup?.businessGroupName || '', sm: 12, md: 4 },
                { label: 'Address', value: `${companyDetail.billingStreet || ''}, ${companyDetail.billingCity?.name || ''}, ${companyDetail.billingState?.name || ''}, ${companyDetail.billingCountry?.name || ''} ${companyDetail.billingPincode || ''}.`.trim() },
                { label: 'Pan Number', value: tax.panNumber || '', sm: 12, md: 4 },
                { label: 'Iec Number', value: tax.iecNumber || '', sm: 12, md: 4 },
                { label: 'Gst Number', value: tax.gstNumber || '', sm: 12, md: 12 },
            ],
        },
    ];

    const handleOpen = () => {
        setModal(true);
    };
    const handleClose = () => {
        setModal(false)
    }

    const handleOpenUpdate = () => {
        setUpdateModal(true);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };


    const buttonTitle = tax.panNumber ? "Update Tax Info" : "Update Tax Info";
    const handleChange = () => {
        if (tax.panNumber) {
            handleOpenUpdate();
        } else {
            handleOpen();
        }
    };

    return (
        <>
            <div>
                <CustomLoader open={loading} />
                <ClientCompanyDetail
                    data={clientCompany}
                    Icon={BusinessOutlinedIcon}
                    handleOpen={handleChange}
                    buttonTitle={buttonTitle}
                />
                <CustomModal
                    open={modal}
                    handleClose={handleClose}
                    modalStyles={{
                        maxHeight: '50vh',
                        top: "10%",
                    }}
                >
                    <CreateCompanyInfo
                        fetchCompanyTax={fetchCompanyTax}
                        clientCompanyTax={clientCompanyTax}
                        companyDetail={clientCompany}
                        setMessage={setMessage}
                        handleClose={handleClose}
                    />
                </CustomModal>

                <CustomModal
                    modalStyles={{
                        maxHeight: '50vh',
                        top: "10%",
                    }}
                    open={updateModal} handleClose={handleCloseUpdate}>
                    <UpdateCompanyInfo
                        clientCompanyId={clientCompanyId}
                        clientCompanyTax={clientCompanyTax}
                        tax={tax}
                        fetchCompanyTax={fetchCompanyTax}
                        companyDetail={clientCompany}
                        setMessage={setMessage}
                        handleClose={handleCloseUpdate}
                    />
                </CustomModal>

                <br />
                <CompanyCall data={companyDetail} />
                <br />
                <CompanyTask data={companyDetail} />
                <br />
                <CompanyNotes data={companyDetail} />
                <br />
                <CustomCollapse Icon={PersonOutlineOutlinedIcon} data={adminData} />
                <br />

                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
            </div >
        </>
    );
}

